import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractRadioInput} from "../abstract-radio-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditRadioInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-radio-input",
    styleUrls: ["./edit-radio-input.component.scss"],
    templateUrl: "./edit-radio-input.component.html",
    standalone: false
})
export class FUIEditRadioInputComponent extends FUIAbstractRadioInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}

